<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="page_vii"></a>Contents</h2>
<p class="toc"><span href="#/html/cover" title="Link target outside of Sample"><em>Cover</em></span></p>
<p class="toc"><span href="#/html/9780226014746_04_cpy" title="Link target outside of Sample"><em>Copyright</em></span></p>
<p class="toc"><a href="#/html/9780226014746_07_pre#pre"><em>Preface</em></a></p>
<p class="toc-chapt"><a href="#/html/9780226014746_08_ch1#ch1">1   Introduction</a></p>
<p class="toc-chap"><a href="#/html/9780226014746_09_ch2#ch2">2   Variance Everywhere</a></p>
<p class="toc-chap"><span href="#/html/9780226014746_10_ch3#ch3" title="Link target outside of Sample">3   The Aristocrats</span></p>
<p class="toc-chap"><span href="#/html/9780226014746_11_ch4#ch4" title="Link target outside of Sample">4   A Matter of Honor</span></p>
<p class="toc-chap"><span href="#/html/9780226014746_12_ch5#ch5" title="Link target outside of Sample">5   The Royal Navy</span></p>
<p class="toc-chap"><span href="#/html/9780226014746_13_ch6#ch6" title="Link target outside of Sample">6   Purchasing Army Commissions</span></p>
<p class="toc-chap"><span href="#/html/9780226014746_14_ch7#ch7" title="Link target outside of Sample">7   Lighthouses, Private Roads, and the Treasury</span></p>
<p class="toc-chap"><span href="#/html/9780226014746_15_ch8#ch8" title="Link target outside of Sample">8   The Courts, Criminal Law, and Police</span></p>
<p class="toc-chapb"><span href="#/html/9780226014746_16_ch9#ch9" title="Link target outside of Sample">9   Conclusion</span></p>
<p class="toc"><span href="#/html/9780226014746_17_not#note" title="Link target outside of Sample"><em>Notes</em></span></p>
<p class="toc"><span href="#/html/9780226014746_18_bib#bib" title="Link target outside of Sample"><em>Bibliography</em></span></p>
<p class="toc"><span href="#/html/9780226014746_19_ind#ind" title="Link target outside of Sample"><em>Index</em></span><a id="page_viii"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780226014746_06_toc.vue?c379af8e